import { CATEGORY_ID } from '../constants/category';
import properyItemModel from '../models/properyItem';
import lookingToMeetApi from '../api/lookingToMeetApi';

class LookingToMeetService {

  loadLookingForData(params) {
    return lookingToMeetApi
      .loadLookingForData(params)
      .then(res => {
        if (res.success) {
          let propertyItems = properyItemModel.mappingObjects(res.data.items);
          propertyItems = properyItemModel.getIconObjects(CATEGORY_ID.LTM_LOOKING_FOR, propertyItems);
          res.data.items = propertyItems;
        } else {
          console.log('ERROR: lookingTomMeetService/loadLookingForData:', res);
        }
        return res;
      })
      .catch(e => {
        console.log('ERROR: lookingTomMeetService/loadLookingForData:', e);
        throw new Error('failed');
      });
  }

  loadAgeRangeData(params) {
    return lookingToMeetApi
      .loadAgeRangeData(params)
      .then(res => {
        if (!res.success) {
          console.log('ERROR: lookingTomMeetService/loadAgeRangeData:', res);
        }
        return res;
      })
      .catch(e => {
        console.log('ERROR: lookingTomMeetService/loadAgeRangeData:', e);
        throw new Error('failed');
      });
  }

  loadIntentionsData(params) {
    return lookingToMeetApi
      .loadIntentionsData(params)
      .then(res => {
        if (res.success) {
          res.data.items = properyItemModel.mappingObjects(res.data.items);
        } else {
          console.log('ERROR: lookingTomMeetService/loadIntentionsData:', res);
        }
        return res;
      })
      .catch(e => {
        console.log('ERROR: lookingTomMeetService/loadIntentionsData:', e);
        throw new Error('failed');
      });
  }
}

export default new LookingToMeetService();
